exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image {\n  width: 100px;\n  height: 100px;\n  background-color: #ecf0f5; }\n\n.img-style {\n  width: 100px;\n  height: 100px; }\n\n.fa-times-circle {\n  position: absolute;\n  top: -1px;\n  right: 1px;\n  cursor: pointer; }\n\n.image-d {\n  position: relative; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/pages/image-changes/image-changes.component.scss
// module id = ../../../../../src/app/main/pages/image-changes/image-changes.component.scss
// module chunks = main